module.exports = __webpack_public_path__ + "img/laspi.1f99fbe0.webp";